import React from 'react';
import { TableRow, TableCell, TableHead, TableSortLabel, Tooltip } from '@material-ui/core';

const EnhancedTableHead = ({ order, orderBy, labels, intl, translationKey, onRequestSort }) => {
    const createSortHandler = (property) => () => {
        onRequestSort(property);
    };

    if (!labels) {
        return null;
    }

    return (
        <TableHead>
            <TableRow>
                {labels.map(
                    (label, index) => (
                        <TableCell
                            key={label.fieldName || index}
                            align={label.align || 'left'}
                            padding={label.disablePadding ? 'none' : 'default'}
                            sortDirection={orderBy === label.fieldName ? order : false}
                        >
                            <Tooltip
                                title={intl.formatMessage({
                                    id: 'Common.sort',
                                })}
                                placement={label.numeric ? 'bottom-end' : 'bottom-start'}
                                enterDelay={300}
                            >
                                <TableSortLabel
                                    active={orderBy === label.fieldName}
                                    direction={order}
                                    onClick={createSortHandler(label.fieldName)}
                                >
                                    {intl.formatMessage({
                                        id: `${translationKey}.${label.fieldName}`,
                                    })}
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                    ),
                    this
                )}
            </TableRow>
        </TableHead>
    );
};

export default EnhancedTableHead;
